import axios from 'axios';
import type { OnboardConfirm } from '../types/OnboardConfirm';
import type { CurrentUserInterface } from '../types/User';
import { baseUrl } from './base';

export async function postSignIn(email: string, password: string) {
  const resp = await axios.post(`${baseUrl.SHARED}/auth/users/sign_in`, {
    email,
    password,
  });

  return resp.data;
}

export async function signOutUser() {
  const resp = await axios.get(`${baseUrl.SHARED}/auth/users/sign_out`);
  return resp.data;
}

export async function getCurrentUser() {
  const resp = await axios.get<{ data: CurrentUserInterface }>(`${baseUrl.SHARED}/auth/users/current`);
  return resp.data;
}

export async function validateToken(token: string) {
  const response = await axios.get(`${baseUrl.SHERPA}/invitations/valid?token=${token}`);
  return response.data;
}
export async function clientOnboard(data: OnboardConfirm) {
  const response = await axios.post<{}>(`${baseUrl.OS}/accounts/onboard/confirm`, data);
  return response;
}
